import { useIntl } from "react-intl"
import { cn } from "@/lib/utils"

/** A two-sided study card. Click, tap, Space, or Enter flips it. */
export function FlipCard({
  front,
  back,
  flipped,
  onFlip,
}: {
  front: string
  back: string
  flipped: boolean
  onFlip: () => void
}) {
  const intl = useIntl()
  return (
    <button
      type="button"
      onClick={onFlip}
      aria-label={flipped ? intl.formatMessage({ id: "flashcards.aria_answer" }) : intl.formatMessage({ id: "flashcards.aria_question" })}
      className="group block w-full cursor-pointer perspective-[1200px] focus-visible:outline-none"
    >
      <div
        className={cn(
          "relative grid min-h-72 transition-transform duration-500 transform-3d motion-reduce:transition-none",
          flipped && "rotate-y-180",
        )}
      >
        <CardFace label={intl.formatMessage({ id: "flashcards.question" })} text={front} />
        <CardFace label={intl.formatMessage({ id: "flashcards.answer" })} text={back} back />
      </div>
    </button>
  )
}

function CardFace({ label, text, back = false }: { label: string; text: string; back?: boolean }) {
  const intl = useIntl()
  return (
    <div
      className={cn(
        "col-start-1 row-start-1 flex flex-col rounded-2xl p-6 shadow-xs ring-1 ring-ink-display/10 backface-hidden sm:p-10 dark:ring-white/10",
        "group-focus-visible:ring-2 group-focus-visible:ring-accent",
        back ? "rotate-y-180 bg-surface" : "bg-page",
      )}
    >
      <span className="text-xs uppercase tracking-wider text-ink-muted">{label}</span>
      <div className="flex flex-1 items-center justify-center py-6">
        <div className="whitespace-pre-wrap break-words text-center text-lg leading-relaxed text-ink-display">
          {text}
        </div>
      </div>
      <span className="text-center text-xs text-ink-muted">{intl.formatMessage({ id: "flashcards.flip_hint" })}</span>
    </div>
  )
}
